<h2 mat-dialog-title>提醒</h2>
<mat-dialog-content class="mat-typography">
  <h3>{{data.message}}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light mr-3" (click)="close(false)">取消</button>
  <button class="btn btn-info" (click)="close(true)">確定</button>
</mat-dialog-actions>